import React from 'react';
import './Footer.css';

const Footer = () => {
	return (
		<footer className='text-center'>
			<p className='bg-green-800 text-white text-center'>&copy; 2022 all right reserved by <a href='https://github.com/hasanrafi69'>yumyum.com</a> </p>
		</footer>
	);
};

export default Footer;